import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  private excludedRoutes = [
    '/login',
    '/create-password-recover',
    '/users/password-recover',
    '/finalize-registration',
  ];

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
  }

  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loadingService.showLoading();

    if (!(request.body))
      request = request.clone({
        setHeaders: {
          // 'Content-Type': 'application/json',
        },
      });

    const isExcludedRoute = this.excludedRoutes.some((route) =>
      request.url.includes(route)
    );
    if (!isExcludedRoute) {
      request = request.clone({
        setHeaders: {
          platform: 'desktop',
        },
      });
      return next.handle(request).pipe(
        finalize(() => this.loadingService.hideLoading())
      );
    }

    return next.handle(request).pipe(
      finalize(() => this.loadingService.hideLoading())
    );
  }
}